<template>
  <div class="assigRulesBox">
    <div class="code_left_bton">
      <el-button type="primary" round class="btn-custom-yellow" style="width: 80px; padding: 0" @click="transferDialog = true">Transfer</el-button>
      <!-- 红色背景按钮 -->
      <el-button type="primary" round class="btn-custom-red" style="width: 80px; padding: 0" @click="zoneCreateHandle">NEW</el-button>
    </div>
    <div class="innerLeft">
      <div>
        <el-tabs v-model="zoneActiveNames"  stretch @tab-click="changeShowNew">
          <el-tab-pane label="Zones" name="first">
              <ra-search-box
                class="mt-4"
                  ref="zipCodeSearch"
                  id="zipCodeSearch"
                  :search-fields="searchColumn"
                  @search="searchHandler"
                  @clear="clearCodeHandle"
               ></ra-search-box>
            <div class="tasksTable"  v-loading="zone_loading">
              <div class="innerTop">
                <div class="outTable"  v-if="zoneList.length!= 0">
                  <el-table
                    :data="zoneList"
                    style="width: 100%;font-weight: normal;">
                    <el-table-column
                      width="55">
                      <template slot-scope="scope">
                        <div v-if="scope.row.status == 1">
                          <img class="w-4" src="../../assets/activate.png" alt="">
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="MA Code"
                      prop="ma_code"
                      min-width="25%"
                    >
                    </el-table-column>
                    <el-table-column
                      label="Zone code"
                      prop="zone_code"
                      min-width="30%"
                    >
                    </el-table-column>
                    <el-table-column
                      prop="province"
                      label="Province"
                      width="300px"
                    >
                    </el-table-column>
                    <el-table-column
                      label="Included postal codes"
                      prop="included_postal_codes"
                      align="left"
                    >
                    </el-table-column>
                    <el-table-column
                      label="Zone name"
                      prop="zone_name"
                      align="left"
                      width="200px"
                    >
                    </el-table-column>
                    <el-table-column
                      header-align="center"
                      align="center"
                      prop="actions"
                      width="200"
                      label="Actions">
                      <template slot-scope="scope">
                        <div class="action">
<!--                            1 启用 0 禁用-->
                          <span  v-if="scope.row.status == 1" @click="zipCodeActiveHandle(1,scope.row)">
                            <img src="../../assets/zipCode/activate@2x.png" alt="">
                          </span>
                          <span  v-else  @click="zipCodeActiveHandle(3,scope.row)">
                            <img src="../../assets/zipCode/ban@2x.png" alt="">
                          </span>
                          <span  @click="zipCodeDeleteHandle(scope.row)">
                        <img src="../../assets/zipCode/delete@2x.png" alt="">
                        </span>
                          <span @click="zipCodeEditHandle(scope.row)">
                          <img src="../../assets/zipCode/edit@2x.png" alt="">
                        </span>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <table-empty v-else></table-empty>
              </div>
            </div>
            <ra-pagination
                :current-page="zone_page"
                :list-length="zoneList.length"
                :total="zone_total"
                @pageChange="handleZoneSizeChange"
            ></ra-pagination>
          </el-tab-pane>
          <el-tab-pane label="Metropolitan area" name="second">
               <metr-area :provinceOption="provinceOption" :areaCodeOption="areaCodeOption" ref="metr_area"></metr-area>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--新增编辑zone弹框-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      :title="zoneTitle"
      :visible.sync="zoneCreatDialog"
      top="5vh"
      :before-close="closeClear"
      width="35%">
      <div>
        <el-form :model="zoneCreateForm" label-position="top" :rules="zoneRulesForm" status-icon ref="zipCodeRef" :show-message="false">
          <el-form-item label="Province" prop="province">
            <el-select v-model="zoneCreateForm.province" placeholder="Province" @change="changeProvinceHandle">
              <el-option
                v-for="item in provinceOption"
                :key="item.code"
                :label="item.code"
                :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Metropolitan area code" prop="ma_code">
            <el-select v-model="zoneCreateForm.ma_code" placeholder="Select a Metropolitan area code" @change="changeMacodeHandle">
              <el-option
                v-for="item in areaCodeOption"
                :key="item.ma_code"
                :label="item.ma_code"
                :value="item.ma_code">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Zone code" prop="zone_number">
            <div class="zone_code_box">
              <div>
                <el-select v-model="zoneCreateForm.zone_number" placeholder="Select">
                  <el-option
                    v-for="item in zone_number_option"
                    :key="item.number"
                    :label="item.number"
                    :value="item.number">
                  </el-option>
                </el-select>
              </div>
              <div>
                <el-input placeholder="Input a zone letter" v-model="zoneCreateForm.zone_letter"></el-input>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="Zone Name">
            <el-input placeholder="Input a zone name" v-model="zoneCreateForm.zone_name"></el-input>
          </el-form-item>

          <el-form-item label="Included postal codes">
            <div class="outZip" @click="focusOn">
              <div class="innerText">
                <el-tag
                  v-for="tag in tags"
                  :key="tag.name"
                  closable
                  @close="handleClose(tag)"
                  :type="tag.type">
                  {{tag.name}}
                </el-tag>
                <div class="innerInput">
                  <input type="text"
                         ref="inputs"
                         v-model="zipCodeInput"
                         maxlength="3"
                         @keyup.enter="keyUpHandler"
                  />
<!--                  <input type="text"-->
<!--                         ref="inputs"-->
<!--                         v-model="zipCodeInput"-->
<!--                         @keyup.delete="deleteTag"-->
<!--                         onkeydown="this.onkeyup();"-->
<!--                         onkeyup="this.size=(this.value.length>4?this.value.length:2);"-->
<!--                         size="2">-->
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="float:left;" v-if="zoneTitle == 'Edit a zone'">
          <ra-select-button :active_mes="zoneCreateForm.status == 1 ? 'Deactivate' :'Activate'"
                            @changeDropHandle="changeDropHandle"></ra-select-button>
        </div>
          <el-button type="success" round style="width: 80px;padding: 0"  @click="cancelZoneCreate" >Cancel</el-button>
          <el-button plain class="changeFocus" @click="confirmZoneCreate">Submit</el-button>
      </span>
    </el-dialog>
    <!--    delete /active/ deactive-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      :title="zipCodeDeleteTitle"
      :visible.sync="zipCodeDeleteDialog"
      width="35%">
      <div class="addInner" v-if="zipCodeDelete == 1" style="margin-top: 24px">
        Will you deactivate this zone? Users cannot place an order if the sender's or recipient's postal code is in this zone.
      </div>
      <div class="addInner" v-if="zipCodeDelete == 3" style="margin-top: 24px">
        Will you activate this zone? Users can place an order if the sender's or recipient's postal code is in this zone.
      </div>
      <div class="addInner" v-if="zipCodeDelete == 2" style="margin-top: 24px">
        Will you delete this zone? Users can no longer place an order if the sender's or recipient's address is in this zone.
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain style="width: 80px" class="changeFocus"  @click="zipCodeDeleteDialog = false">No</el-button>
        <el-button type="success" round style="width: 80px;padding: 0"  @click="zipCodeConfirmDelete">Yes</el-button>
  </span>
    </el-dialog>
<!--    transfer-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      title="Transfer Postal Codes"
      :visible.sync="transferDialog"
      @close="closeTransferHandle"
      top="5vh"
      width="35%">
      <div>
        <el-form :model="transferForm" label-position="top" :rules="transferRulesForm" status-icon ref="perTasksRef" :show-message="false">
          <el-form-item label="From" required prop="from">
            <el-select v-model="transferForm.from" placeholder="Zone Code">
              <el-option
                v-for="item in zoneList"
                :key="item.id"
                :label=" item.zone_code+ ' ' + item.zone_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="To" required prop="to">
            <el-select v-model="transferForm.to" placeholder="Zone Code">
              <el-option
                v-for="item in zoneList"
                :key="item.id"
                :label=" item.zone_code+ ' ' + item.zone_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="success" round style="width: 80px;padding: 0"  @click="transferDialog = false" >Cancel</el-button>
          <el-button plain class="changeFocus" @click="confirmAreaCreate">Submit</el-button>
      </span>
    </el-dialog>
<!--    确认转移-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      :modal="false"
      title="Transfer confirmation"
      :visible.sync="confirmTransferDialog"
      top="10vh"
      width="25%">
      <div>
        <div>Will transfer 2 postal codes from {{transfer_from.zone_code}} ({{transfer_from.zone_name}}) to {{transfer_to.zone_code}} （{{transfer_to.zone_name}}）?</div>
        <div>Included postal codes: {{transfer_from.included_postal_codes}}</div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="success" round style="width: 80px;padding: 0"  @click="confirmTransferDialog = false" >No</el-button>
          <el-button plain class="changeFocus" @click="confirmAreaCreateHandle">Yes</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import metrArea from "@/components/metr-area";
import RaSelectButton from "@/components/ra-select-button.vue";
import {searchColumn} from "@/view/zipCode/searchColumn";
import RaPagination from "@/components/ra-pagination.vue";
import {
  createZone,
  deleteZone, editZone,
  getAvailableZoneNumbers,
  getMADropdownList,
  getProvinceList,
  getZoneList, transferPostalCodes,
  updateZoneStatus
} from "@/api/zipCode";
import {getAllPublicData} from "@/api/order";
export default {
  name: "assigRules",
  components: {
    RaSelectButton,
    RaPagination,
    metrArea
  },
  data(){
    return{
      transfer_from:{},
      transfer_to:{},
      confirmTransferDialog:false,
      searchColumn,
      // 控制tabs激活状态的变量
      zoneActiveNames: 'first',
      // 搜索框相关
      pcOption: [], // 包含邮政编码选项列表
      // 表格加载状态
      zone_loading: true,
      // 区域列表数据
      zoneList: [], // 存储区域数据的数组
      // 分页相关
      zone_page: 1, // 当前页数
      zone_total: 0, // 总条数
      zoneTitle:'Create a zone',
      zoneCreatDialog:false,
      zoneCreateForm:{
        province:"",
        ma_code:'',
        zone_number:'',
        zone_name:"",
        zone_letter:""
      },
      zoneRulesForm: {
        province: [
          { required: true, message: '', trigger: 'change' }
        ],
        ma_code: [
          { required: true, message: '', trigger: 'change' }
        ],
        zone_number: [
          { required: true, message: '', trigger: 'change' }
        ],
        zone_letter: [
          { required: true, message: '', trigger: 'blur' }
        ],
        zone_name: [
          { required: true, message: '', trigger: 'blur' }
        ],
        postal_codes: [
          { required: true, message: '', trigger: 'blur' }
        ]
      },
      provinceOption:[],
      zone_number_option:[],
      tags:[],
      zipCodeInput:'',
      zipCodeDeleteTitle:"Delete this zone",
      zipCodeDeleteDialog:false,
      zipCodeDelete:0,
      transferDialog:false,
      transferForm:{},
      transferRulesForm:{
        from: [
          { required: true, message: '', trigger: 'blur' }
        ],
        to: [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      areaCodeOption:[],
      deleteZoneItem:{},
      initparms :{
        ma_code:'',
        zone_code:'',
        province:'',
        included_postal_codes:'',
      }
    }
  },
  watch:{
    // zipCodeInput: {
    //   deep: true,
    //   handler: function (n, o) {
    //     // 输入逗号，生成标签
    //     if (n.indexOf(',') > -1) {
    //       this.zipCodeInput = this.zipCodeInput.split(',')[0];
    //       this.tags.push({name:this.zipCodeInput})
    //       this.zipCodeInput = ""
    //     }
    //   },
    // },
    zoneCreatDialog(newVal) {
      if (!newVal) {
        this.closeClear(); // 在关闭弹框时调用
      }
    }
  },
  created() {
    this.getZoneListHandle(this.initparms)
    this.getProvinceListHandle()
  },

  methods: {
    getProvinceListHandle(){
      getProvinceList().then(res => {
        if (res.code === 200) {
          this.provinceOption = res.data.provinces
          searchColumn.forEach(v=>{
            if (v.label == "Province"){
              v.options = res.data.provinces
            }
          })
        }
      })
    },
    changeProvinceHandle(val){
      this.zoneCreateForm.ma_code = ''
      this.zoneCreateForm.zone_number = ''
      this.$nextTick(()=>{
        this.$refs.zipCodeRef.clearValidate(['ma_code','zone_number'])
      })
        this.getMADropdownListHandle(val)
    },
    getMADropdownListHandle(val){
      getMADropdownList({
        province:val,
      }).then(res=>{
        this.areaCodeOption = res.data.list
      })
    },
    changeMacodeHandle(val){
      this.zoneCreateForm.zone_number = ''
      this.$nextTick(()=>{
        this.$refs.zipCodeRef.clearValidate('zone_number')
      })
      this.getAvailableZoneNumbersHandle(val)
    },
    getAvailableZoneNumbersHandle(val) {
      getAvailableZoneNumbers({
        ma_code:val,
      }).then(res=>{
        this.zone_number_option = res.data.numbers
      })
    },
    getZoneListHandle(obj){
      this.zone_loading = true
      obj.page = this.zone_page
      obj.limit = 10
      getZoneList(obj).then(res=>{
        this.zone_loading = false
          if(res.code == 200){
            this.zoneList = res.data.list
            this.zone_total = res.data.total
          }
      })
    },
    confirmAreaCreateHandle(){
      transferPostalCodes({
        from_ma_code:this.transfer_from.ma_code,
        from_zone_code:this.transfer_from.zone_code,
        to_ma_code:this.transfer_to.ma_code,
        to_zone_code:this.transfer_to.zone_code,
      }).then(res=>{
        if (res.code == 200){
          this.transferDialog = false;
          this.confirmTransferDialog = false
          this.getZoneListHandle(this.initparms);
          this.$message({
            type:"success",
            message:res.msg
          })
        }else {
          this.$message({
            type:"error",
            message:res.msg
          })
        }
      })
    },
    confirmAreaCreate(){
      this.$refs.perTasksRef.validate(valid => {
        if  (valid){
          this.transfer_from = this.zoneList.find(item => this.transferForm.from === item.id) || null;
          this.transfer_to = this.zoneList.find(item => this.transferForm.to === item.id) || null;
          this.confirmTransferDialog = true;
        }else{
          this.$message({
            type:'warning',
            message:'Some information missing'
          })
        }
      })
    },
    closeTransferHandle(){
      this.transferForm.from = ''
      this.transferForm.to = ''
      this.$nextTick(()=>{
        this.$refs.perTasksRef.clearValidate()
      })
    },
    searchHandler(params) {
      this.initparms = params
      this.getZoneListHandle(params)
    },
    clearCodeHandle(params){
      this.initparms = params
      this.getZoneListHandle(this.initparms)
    },
    handleZoneSizeChange (val){
      this.zone_page = val
      this.initparms.page = 1
      this.initparms.limit = 10
      this.getZoneListHandle(this.initparms)
    },
    changeShowNew(){
      if (this.zoneActiveNames === 'first') {
        this.$refs.zipCodeSearch.calcPaddingLeft()
      } else {
        this.$refs.metr_area.$refs.areaSearch.calcPaddingLeft()
      }
    },
    zipCodeActiveHandle(a,row){
      if (a == 1){
        this.zipCodeDeleteTitle = 'Deactivate this zone'
      }else {
        this.zipCodeDeleteTitle = 'Activate this zone'
      }
          this.zipCodeDelete = a
          this.deleteZoneItem = row
          this.zipCodeDeleteDialog = true
    },
    zipCodeDeleteHandle(row){
      this.zipCodeDelete = 2
      this.zipCodeDeleteTitle = 'Delete this zone'
      this.deleteZoneItem = row
      this.zipCodeDeleteDialog = true
    },
    zipCodeEditHandle(row) {
      this.zoneCreateForm = { ...row }; // 使用展开运算符创建一个新对象
      this.tags = [];
      let arr = row.included_postal_codes.split(',');
      arr.forEach(item => {
        if (item != ''){
          this.tags.push({ name: item });
        }
      });
      this.getMADropdownListHandle(row.province)
      this.getAvailableZoneNumbersHandle(row.ma_code)
      this.zoneTitle = 'Edit a zone';
      this.zoneCreatDialog = true;
    },
    keyUpHandler() {
      this.zipCodeInput = this.zipCodeInput.trim();
      if (!this.zipCodeInput) return
      const includeInput = this.tags.some((item) => item.name === this.zipCodeInput);
      if (!includeInput) {
        this.tags.push({ name: this.zipCodeInput });
      }
      this.zipCodeInput = '';
    },
    closeClear() {
      this.tags = [];
      this.zipCodeInput = ''
      // 使用深拷贝
      this.zoneCreateForm = JSON.parse(JSON.stringify({
        province: "",
        ma_code: '',
        zone_number: '',
        zone_name: "",
        zone_letter: ""
      }));
      this.zoneCreatDialog = false
      this.$nextTick(() => {
        this.$refs.zipCodeRef.clearValidate();
      });
    },
    changeDropHandle(val){
      console.log(val,'ddd')
      if (val == 'Delete'){
       this.zipCodeDeleteHandle(this.zoneCreateForm)
      }else if (val == 'Deactivate'){
       this.zipCodeActiveHandle(1,this.zoneCreateForm)
      }else{
        this.zipCodeActiveHandle(3,this.zoneCreateForm)
      }
    },
    cancelZoneCreate() {
      this.tags = [];
      this.zipCodeInput = ''
      // 使用深拷贝
      this.zoneCreateForm = JSON.parse(JSON.stringify({
        province: "",
        ma_code: '',
        zone_number: '',
        zone_name: "",
        zone_letter: ""
      }));
      this.$nextTick(() => {
        this.$refs.zipCodeRef.clearValidate();
      });
      this.zoneCreatDialog = false;
    },
    focusOn(){
      this.$refs.inputs.focus()
    },
    handleClose(val){
      this.tags.splice(this.tags.indexOf(val), 1);
      this.$refs.inputs.focus()
    },
    deleteTag(){

    },

    confirmZoneCreate(){
      let arr = []
      this.tags.forEach(item => {
        arr.push(item.name)
      })
      this.zoneCreateForm.included_postal_codes = arr
      console.log(this.zoneCreateForm.included_postal_codes)
      this.$refs.zipCodeRef.validate((valid)=>{
        if (valid){
          this.zoneCreateForm.zone_code = this.zoneCreateForm.zone_number + this.zoneCreateForm.zone_letter
          if  (this.zoneTitle == 'Create a zone'){
            createZone(this.zoneCreateForm).then(res=>{
              if (res.code == 200){
                this.zoneCreatDialog = false
                this.getZoneListHandle(this.initparms)
              }else {
                this.$message({
                  type:'error',
                  message:res.msg
                })
              }
            })
          }else{
            editZone(this.zoneCreateForm).then(res=>{
              if (res.code == 200){
                this.zoneCreatDialog = false
                this.getZoneListHandle(this.initparms)
              }else {
                this.$message({
                  type:'error',
                  message:res.msg
                })
              }
            })
          }
        }
      })

    },
    zoneCreateHandle(){
      if(this.zoneActiveNames == 'first'){
        this.zoneCreatDialog = true
        this.zoneTitle = 'Create a zone'
      }else {
       this.$refs.metr_area.areaCreatDialog = true
       this.$refs.metr_area.areaTitle = 'Create a metropolitan area'
      }
    },
    zipCodeConfirmDelete(){
      if (this.zipCodeDelete == 1 || this.zipCodeDelete == 3){
        //禁用
        updateZoneStatus({
          id:this.deleteZoneItem.id,
          status:this.deleteZoneItem.status == 1? 0 : 1
        }).then(res=>{
          if  (res.code == 200){
            this.zipCodeDeleteDialog = false
            this.zoneCreatDialog = false
            this.initparms.page = 1
            this.initparms.limit = 10
            this.getZoneListHandle(this.initparms)
            this.$message({
              type: 'success',
              message:"Successfully deactivated"
            })
          }else {
            this.$message({
              type:'error',
              message:res.msg
            })
          }

        })
      }else{
        //删除
        deleteZone({
          id:this.deleteZoneItem.id
        }).then(res=>{
          if (res.code == 200){
            this.zipCodeDeleteDialog = false
            this.zoneCreatDialog = false
            this.initparms.page = 1
            this.initparms.limit = 10
            this.getZoneListHandle(this.initparms)
            this.$message({
              type: 'success',
              message:"Successfully deleted"
            })
          }else {
            this.$message({
              type:'error',
              message:res.msg
            })
          }
        })
      }

    }
  }
}
</script>
<style scoped lang="less">
  @import "zipCode";
</style>
